import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import useColors from "api/hooks/useColors";

const KpiCard = ({ title, value, color, subtitle }) => {
  const colors = useColors();

  return (
    <Card
      sx={{
        boxShadow: `0px 0px 2px 1px ${colors.divider2}`,
        borderRadius: "10px",
        height: "100%",
      }}
    >
      <CardContent sx={{ padding: "16px !important" }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ marginBottom: "8px" }}
        >
          {title}
        </Typography>
        <Typography variant="h4" sx={{ color: color || colors.primary_main }}>
          {value}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

const InternalDashboardKpis = ({ summary }) => {
  const colors = useColors();

  const kpis = [
    {
      title: "Customers",
      value: summary?.customers_count || 0,
      color: colors.primary_main,
    },
    {
      title: "Environments",
      value: summary?.environments || 0,
      color: colors.secondary_main,
    },
    {
      title: "Unique Integrations",
      value: summary?.unique_tools || 0,
      color: colors.info_main,
    },
    {
      title: "Total Integrations",
      value: summary?.total_tools || 0,
      color: colors.info_dark,
    },
    {
      title: "Unique Controls",
      value: summary?.unique_controls_count || 0,
      color: colors.info_main,
    },
    {
      title: "In Progress",
      value: summary?.scans_in_progress || 0,
      color: colors.warning_main,
    },
    {
      title: "Failed",
      value: summary?.scans_failed || 0,
      color: colors.error_main,
    },
    {
      title: "Successful",
      value: summary?.scans_successful || 0,
      color: colors.success_main,
    },
    {
      title: "Total Entities",
      value: summary?.entities_total || 0,
      color: colors.primary_dark,
    },
    {
      title: "Total Controls",
      value: summary?.controls_total || 0,
      color: colors.primary_main,
    },
    {
      title: "Gap",
      value: summary?.controls_summary?.Gap || 0,
      color: colors.error_main,
    },
    {
      title: "Compliant",
      value: summary?.controls_summary?.Compliant || 0,
      color: colors.success_main,
    },
    {
      title: "Snoozed",
      value: summary?.controls_summary?.Snoozed || 0,
      color: colors.warning_main,
    },
    {
      title: "Excluded",
      value: summary?.controls_summary?.Excluded || 0,
      color: colors.text_secondary,
    },
  ];

  return (
    <Box sx={{ marginTop: "24px", marginBottom: "24px" }}>
      <Grid container spacing={2}>
        {kpis.map((kpi, index) => (
          <Grid item xs={12} sm={6} md={3} lg={1.5} key={index}>
            <KpiCard
              title={kpi.title}
              value={kpi.value}
              color={kpi.color}
              subtitle={kpi.subtitle}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default InternalDashboardKpis;
